import clsx from "clsx";
import type { ReactNode } from "react";

/**
 * 「アイコン + タイトル + 本文 + アクション」型の InformationItem (FAQ / Tips 共通)。
 * 本文の色 / HTML 化は呼び出し側で children に指定する (FAQ と Tips で色が違うため)。
 * title 省略時はヘッダ行を出さず本文のみ描画する (見出し未設定の Tips データ向け)。
 */
type DxInformationItemProps = {
  icon?: ReactNode;
  title?: ReactNode;
  titleAs?: "h2" | "h3" | "p";
  action?: ReactNode;
  children: ReactNode;
  className?: string;
};

export function DxInformationItem({
  icon,
  title,
  titleAs = "h3",
  action,
  children,
  className,
}: DxInformationItemProps) {
  const Title = titleAs;
  const hasHeader = title !== undefined || icon !== undefined;
  return (
    <div className={clsx("flex flex-col items-start", className)}>
      {hasHeader && (
        // title が 2 行折り返してもアイコンは 1 行目中央に保つ (dx-icon-baseline)。
        <div className="dx-subhead flex w-full items-start gap-[12px]">
          {icon !== undefined && (
            <span className="dx-icon-baseline">{icon}</span>
          )}
          {title !== undefined && (
            <Title className="text-dx-text-default min-w-0 flex-1">
              {title}
            </Title>
          )}
        </div>
      )}
      {/* ヘッダ有り時のみ本文との間に 4px 空ける (ヘッダ無し時は本文を直接出す)。 */}
      <div
        className={clsx(
          "flex w-full flex-col items-start",
          hasHeader && "pt-[4px]",
        )}
      >
        {children}
        {action !== undefined && action}
      </div>
    </div>
  );
}
